import { render, staticRenderFns } from "./kv-textarea.vue?vue&type=template&id=139753ef"
import script from "./kv-textarea.vue?vue&type=script&lang=js"
export * from "./kv-textarea.vue?vue&type=script&lang=js"
import style0 from "./kv-textarea.vue?vue&type=style&index=0&id=139753ef&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports